import { Component } from '@angular/core';

@Component({
  selector: 'app-tickets-report',
  templateUrl: './tickets-report.component.html',
  styleUrls: ['./tickets-report.component.scss']
})
export class TicketsReportComponent {
  reports = [
    {
      name: "Tickets by Status",
      description: "Provides a breakdown of support tickets based on their current status such as Open, In Progress, Resolved, or Closed.",
      lastAccessed: "14 min ago",
      slug: "tickets-by-status"
    },
    {
      name: "Tickets by Priority",
      description: "Categorizes tickets based on urgency or importance — e.g., Low, Normal, High, or Urgent — to help prioritize resolution.",
      lastAccessed: "38 min ago",
      slug: "tickets-by-priority"
    },
    {
      name: "Tickets by Source",
      description: "Displays the origin of tickets such as Tina, WhatasApp,  or Manual, enabling insight into support channels.",
      lastAccessed: "12 min ago",
      slug: "tickets-by-source"
    },
    {
      name: "Tickets Assigned To",
      description: "Lists tickets grouped by assigned support agent or team, helping in monitoring workloads and ownership.",
      lastAccessed: "15 min ago",
      slug: "tickets-assign-to"
    }
  ];

}
